import { FeedbackRptService } from "../services";
import { FeedbackRptConstants } from "../constants";
import { alertActions } from ".";

export const FeedbackRptActions = {
  getAll,
  loadingData,
  exportData,
};

function getAll(obj) {
  return (dispatch) => {
    dispatch(request());
    FeedbackRptService.fetchFeedbackData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));

        var data = response.ResponseData;
        // if (data != null) {
        //   data.forEach(function (v) {
        //     delete v.TotalRows;
        //   });
        // }
        dispatch(successExport(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: FeedbackRptConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: FeedbackRptConstants.GETALL_SUCCESS, datas };
  }
  function successExport(datas) {
    return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: FeedbackRptConstants.GETALL_FAILURE, error };
  }
}

function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    FeedbackRptService.fetchFeedbackData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.TotalRows;
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: FeedbackRptConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: FeedbackRptConstants.LOADING_REQUEST,
    isbool,
  };
}
